// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aero_aeroplane_section__ZYQVn {
  position: relative;
  width: 100%;
  height: auto;
  padding: 3rem 2rem;
  background-color: var(--primary-color);

  .aero_child_section__ozsHp {
    margin: 0 0 0 8rem;
    width: 46%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    gap: 0.6rem;

    & h6 {
      color: var(--text-color);
      font-family: Inter;
      font-size: 1.8rem;
      font-weight: 700;
    }

    & p {
     
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.87rem;
      font-weight: 400;
    }

    & button {
      width: 250px;
      font-family: Inter;
      font-size: 1rem;
      font-weight: 400;
      display: flex;
      padding: 16px 19px;
      gap: 10px;
      color: var(--text-color);
      background-color: #ff5c00;
      border: 1px solid #fff;
    }
  }
}

.aero_ap_section__nKfW\\+ {
  display: flex;
  justify-content: flex-end;

  & img {
    z-index: 0;
    position: absolute;
    top: -25px;
    right: 0;
    width: 40%;
    height: auto;
  }
}

/* -------media-queries---------- */

@media screen and (max-width: 568px) {
  .aero_aeroplane_section__ZYQVn {
    position: relative;

    .aero_child_section__ozsHp {
      margin: 0;
      width: 100%;

      & button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .aero_ap_section__nKfW\\+ {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/AeroplaneSection/aero.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;;EAEtC;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;;IAEX;MACE,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;;MAEE,wBAAwB;MACxB,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,YAAY;MACZ,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,aAAa;MACb,kBAAkB;MAClB,SAAS;MACT,wBAAwB;MACxB,yBAAyB;MACzB,sBAAsB;IACxB;EACF;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;;EAEzB;IACE,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,YAAY;EACd;AACF;;AAEA,mCAAmC;;AAEnC;EACE;IACE,kBAAkB;;IAElB;MACE,SAAS;MACT,WAAW;;MAEX;QACE,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;MACzB;IACF;EACF;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".aeroplane_section {\n  position: relative;\n  width: 100%;\n  height: auto;\n  padding: 3rem 2rem;\n  background-color: var(--primary-color);\n\n  .child_section {\n    margin: 0 0 0 8rem;\n    width: 46%;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n    gap: 0.6rem;\n\n    & h6 {\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 1.8rem;\n      font-weight: 700;\n    }\n\n    & p {\n     \n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.87rem;\n      font-weight: 400;\n    }\n\n    & button {\n      width: 250px;\n      font-family: Inter;\n      font-size: 1rem;\n      font-weight: 400;\n      display: flex;\n      padding: 16px 19px;\n      gap: 10px;\n      color: var(--text-color);\n      background-color: #ff5c00;\n      border: 1px solid #fff;\n    }\n  }\n}\n\n.ap_section {\n  display: flex;\n  justify-content: flex-end;\n\n  & img {\n    z-index: 0;\n    position: absolute;\n    top: -25px;\n    right: 0;\n    width: 40%;\n    height: auto;\n  }\n}\n\n/* -------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  .aeroplane_section {\n    position: relative;\n\n    .child_section {\n      margin: 0;\n      width: 100%;\n\n      & button {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  .ap_section {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aeroplane_section": `aero_aeroplane_section__ZYQVn`,
	"child_section": `aero_child_section__ozsHp`,
	"ap_section": `aero_ap_section__nKfW+`
};
export default ___CSS_LOADER_EXPORT___;
